export const languages = {
    ru: {
        type: 'ru',
        numberForm: {
            prefix: 'Все коды',
            mobilePrefix: 'Все',
            button: 'Найти',
            random: 'Подобрать случайно',
            new: 'Новый',
            title: 'Поиск номера',
            caption: 'Введите желаемую комбинацию от 3 до 6 цифр',
            busyNumber:' Данный номер занят, но мы подобрали для вас другие варианты',
            tryAgain: ' занят, проверьте другую комбинацию цифр\n'
        },
        results: {
            options: {
                simple: 'Простой',
                bronze: 'Бронза',
                silver: 'Серебро',
                'silver+': 'Серебро+',
                gold: 'Золото',
                'gold+': 'Золото+',
                platinum: 'Платина',
                VIP: 'VIP',
                more: 'Показать больше'
            },
            bookNumber: 'Забронировать номер'
        },
        modal: {
            thanks: ' Спасибо',
            bookingTitle: 'Бронирование номера?',
            bookingSubtitle: 'Бесплатное бронирование до 1 дня',
            phoneNumber: 'Контактный телефон',
            submit: 'Отправить заявку',
            changeNumber: 'Сменить номер',
            changeMessage: 'Для смены номера вводите комбинацию без пробелов',
            getOffice: 'Для покупки номера просим Вас подойти в ближайший офис продаж и обслуживания.',
            maps: 'https://beeline.kg/ru/map',
            bottomMessage: 'Команда активна в течении 1 дня',
            tutorial: '1. Введите контактный номер, на который будет отправлено сообщение и нажмите "Отправить"\n' +
                '2. Пополните баланс на необходимую сумму в течении 1 дня.\n' +
                '3. Для покупки забронированного номера наберите полученную команду',
            success: 'Успешная бронь!',
            message: 'Мы отправили команду на номер',
            messageKg: '',
            ussdInfo: 'Затем подтвердите USSD-команду.'

        }
    },
    kg: {
        type: 'kg',
        numberForm: {
            prefix: 'Коддор',
            mobilePrefix: 'Код',
            button: 'Издөө',
            random: 'Кокустан таӊдоо',
            new: 'Новый',
            title: 'Номерди издөө',
            caption: 'Жагымдуу сандарды терсеӊиз 3-6 чейин',
            busyNumber:'Бул номер бош эмес, бирок биз сизге башка варианттарды сунуштай алабыз\n',
            tryAgain:'бош эмес, башка сандардын комбинациясын текшерип көрүңүз\n'
        },
        results: {
            options: {
                simple: 'Жөнөкөй',
                bronze: 'Коло  ',
                silver: 'Күмүш',
                'silver+': 'Күмүш+',
                gold: 'Алтын',
                'gold+': 'Алтын+',
                platinum: 'Платина',
                VIP: 'VIP',
                more: 'Дагы көрсөтүү'
            },
        },
        modal: {
            thanks: 'Рахмат',
            bookingTitle: 'Номурду брондоо?',
            bookingSubtitle: '1 күнгө акысыз брондоо ',
            phoneNumber: 'Байланыш телефону',
            submit: 'Билдирме жөнөтүү',
            changeNumber: 'Номерди алмаштыруу',
            changeMessage: 'Номерди өзгөртүш үчун комбинацияны териӊиз',
            getOffice: 'Номер сатып алуу үчүн жакынкы сатуу жана тейлөө кеңсесине барыңыз.',
            maps: 'https://beeline.kg/ky/map',
            bottomMessage: 'Буйрукча 1 күн активдүү ',
            tutorial: '1. Билдирүүнү жиберүү үчүн байланыш номерин киргизип, «Жөнөтүү» баскычын басыңыз.\n 2. Балансты 1 күндүн ичинде керектүү суммага толуктаңыз.\n 3. Ээленген номерди сатып алуу үчүн сизге жиберилген буйрукту териңиз',
            success: 'Ийгиликтүү бронь!',
            message: 'Буйрукча ',
            messageKg: ' номерине жөнөтүлдү',
            ussdInfo: 'Андан кийин USSD-буйругун тастыктаңыз.'
        }
    },

};

export default {
    languages
};
